/* tslint:disable */
/* eslint-disable */
/**
 * PCO - Product & Services
 * API to test if access the application and get the current version
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DistributeDocumentsResponse
 */
export interface DistributeDocumentsResponse {
    /**
     * 
     * @type {string}
     * @memberof DistributeDocumentsResponse
     */
    requestId?: string;
}

/**
 * Check if a given object implements the DistributeDocumentsResponse interface.
 */
export function instanceOfDistributeDocumentsResponse(value: object): value is DistributeDocumentsResponse {
    return true;
}

export function DistributeDocumentsResponseFromJSON(json: any): DistributeDocumentsResponse {
    return DistributeDocumentsResponseFromJSONTyped(json, false);
}

export function DistributeDocumentsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributeDocumentsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'requestId': json['requestId'] == null ? undefined : json['requestId'],
    };
}

export function DistributeDocumentsResponseToJSON(json: any): DistributeDocumentsResponse {
    return DistributeDocumentsResponseToJSONTyped(json, false);
}

export function DistributeDocumentsResponseToJSONTyped(value?: DistributeDocumentsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'requestId': value['requestId'],
    };
}

